/** The surname of a staff name: its last word ("Alex Smith" -> "Smith"; a one-word name is its own surname). */
function surnameOf(name: string): string {
  const words = name.trim().split(/\s+/);
  return words[words.length - 1] ?? "";
}

const collator = new Intl.Collator("en-AU", { sensitivity: "base" });

/** Sort order for staff lists: by surname, then by the whole name ("Alex Smith" before "John Smith"), ignoring case and accents. */
export function bySurname<T extends { name: string }>(a: T, b: T): number {
  return collator.compare(surnameOf(a.name), surnameOf(b.name)) || collator.compare(a.name.trim(), b.name.trim());
}
